import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import cx from 'classnames';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

const LoadingIcon = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  @keyframes sendingToLambda {
    to {
      transform: rotate(360deg);
    }
  }
  &:after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid var(--pinline-grey);
    border-top-color: var(--dark-grey);
    animation: sendingToLambda 0.6s linear infinite;
    margin-left: -10px;
    margin-top: -10px;
  }
`;

const _excluded = ["market", "context", "type", "size", "disabled", "isWaiting", "onClick", "className", "id", "style", "children", "href"];
const SUBTLE = "Subtle";
const SECONDARY = "Secondary-cta";
const SECURE = "Secure-Checkout";
const ADDTOCART = "Add-To-Cart";
const EMAIL = "Email";
const FINDINSTORE = "Find-In-Store";
const ButtonWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items:center;
  justify-content:center;
  width: ${props => props.context === ADDTOCART || props.context === EMAIL || props.context === SECURE ? "100%;" : "auto"};
  max-width: ${props => props.context === ADDTOCART && "400px" || props.context === SECURE && "100%"};
  height: 45px;
  padding: 0 1.5rem;
  margin: 0;
  color: ${props => props.context === SUBTLE || props.context === FINDINSTORE || props.context === SECONDARY ? "black" : "white"};
  text-decoration: none;
  border-radius: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: ${props => props.context === SUBTLE || props.context === FINDINSTORE ? "1px solid black" : "1px solid transparent"};
  font-size: 1.1rem;
  line-height: 1rem;
  font-family: var(--font-urw-din);
  font-weight: 500;
  text-transform: uppercase;
  word-break: keep-all;
  cursor: pointer;
  background-color: ${props => props.context === SUBTLE || props.context === FINDINSTORE || props.context === SECONDARY ? "white" : "black"};

  &:hover {
    border: 1px solid transparent;
    background-image: linear-gradient(#373737, black);
    transition: background-color 400ms ease-in;
    text-decoration: none;
    color: ${props => props.context === SECONDARY ? "black" : "white"};
  }

  &:active {
    border: 1px solid transparent;
    text-decoration: none;
    background-image: linear-gradient(black, #373737);
    transition: background-color 400ms ease-in;
    text-decoration: none;
    color: ${props => props.context === SECONDARY ? "black" : "white"};
  }

  &.waiting, &.is-waiting {
    color: ${props => props.context === SUBTLE || props.context === FINDINSTORE || props.context === SECONDARY ? "white" : "black"};
    pointer-events: none;

    & {
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
  }

  ${props => props.disabled && css`
      &:disabled,
      &.disabled {
        opacity: 0.3;
        color: #ccc;
        cursor: not-allowed;

        &:hover {
          border: 1px solid transparent;
          background-image: none;
        }
      }
    `};
  }

  ${props => props.context === SECURE && css`
      &::after {
        content: url(//images.arcteryx.com/foundation-ui/svgs/Secure_Icon_White.svg);
        width: 10px;
        height: 10px;
        margin-left: 10px;
        display: inline-block;
      }
    `};
  }


  /* Inverted, Secondary-cta buttons */
  &.button--Secondary-cta {
    border: 1px solid transparent;
    border-bottom: 1px solid black;

    &:hover,
    &:active,
    &:focus {
      background: white;
      color: black;
      border: 1px solid black;
    }
  }
  ${props => props.context === FINDINSTORE && css`
      & {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 400px;
        max-width: 100%;
        line-height: 16px;
        text-transform: none;
        &::before {
          content: url(//images.arcteryx.com/foundation-ui/svgs/Pin.svg);
          width: 16px;
          height: 16px;
          margin-right: 5px;
          display: inline-block;
        }
        &:hover {
          color: black;
          border: 1px solid black;
          background-image: none;
          background-color: white;
        }
      }
    `};
  }
  ${props => props.context === EMAIL && css`
      display: inline-flex;
      justify-content: center;
      align-items: center;
      & {
        &::before {
          content: url(//images.arcteryx.com/foundation-ui/svgs/Email_White.svg);
          width: 22px;
          margin-right: 5px;
          display: inline-block;
        }
      }
    `};
  }

  ${props => props.context === ADDTOCART && css`
      display: inline-flex;
      justify-content: center;
      align-items: center;
      & {
        &::before {
          content: url(//images.arcteryx.com/foundation-ui/svgs/Cart_Icon_White.svg);
          width: 22px;
          margin-right: 5px;
          display: inline-block;
        }
      }
    `};
  }
`;
const Button = _ref => {
  let {
      market,
      context,
      type,
      size,
      disabled,
      isWaiting,
      onClick,
      className,
      id,
      style,
      children,
      href = ""
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const baseClass = "button";
  const rootClass = cx(baseClass, className, {
    [`${baseClass}--${market}`]: market,
    [`${baseClass}--${context}`]: context,
    [`${baseClass}--${size}`]: size,
    [`disabled`]: disabled,
    [`waiting`]: isWaiting,
    [`is-waiting`]: isWaiting
  });
  const isAnchorElement = Boolean(href);
  const as = isAnchorElement ? "a" : "button";
  return /*#__PURE__*/React.createElement(ButtonWrapper, _extends({
    as: as,
    id: id,
    href: isAnchorElement ? href : undefined,
    className: rootClass,
    type: isAnchorElement ? undefined : type,
    style: style,
    onClick: onClick,
    size: size,
    market: market,
    context: context,
    disabled: disabled
  }, otherProps), isWaiting ? /*#__PURE__*/React.createElement(LoadingIcon, null) : null, /*#__PURE__*/React.createElement("span", null, children));
};
Button.displayName = "Button";
Button.defaultProps = {
  context: "Standard",
  market: "Outdoor",
  type: "button",
  disabled: false,
  isWaiting: false,
  onClick: null,
  style: {}
};
Button.propTypes = {
  /** Standard, subtle, Secondary-cta, Secure-checkout, Add-To-Cart, Find-In-Store */
  context: PropTypes.string,
  type: PropTypes.string,
  /** Outdoor, Leaf, Veilance*/
  market: PropTypes.oneOf(["Outdoor", "Leaf", "Veilance"]),
  id: PropTypes.string,
  /** xs, sm, md ,lg */
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  disabled: PropTypes.bool,
  isWaiting: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

export { Button };
//# sourceMappingURL=index.js.map
